<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column" [style.gap.rem]="(allocationsHaveChanged$ | async) ? 0.5 : 1">
    <div class="title-md" i18n>Fund Allocation</div>
    <div *ngIf="allocationsHaveChanged$ | async" class="paragraph-lg" i18n>
      {{ descriptionText$ | async }}
    </div>
    <div *ngIf="!(allocationsHaveChanged$ | async)" class="no-changes" i18n>No Changes</div>
  </div>
  <div *ngIf="allocationsHaveChanged$ | async" class="d-flex flex-row gap-4">
    <div class="flex-grow-1">
      <app-fund-allocation-visualization
        label="Current"
        i18n-label
        [donutChartData]="previousAllocationDonutChartData$ | async"
        [borderColor]="'#C63221'"
        [backgroundColor]="'#FCEBEA'" />
    </div>
    <div class="flex-grow-1">
      <app-fund-allocation-visualization
        label="New"
        i18n-label
        [donutChartData]="newAllocationDonutChartData$ | async"
        [borderColor]="'#13856B'"
        [backgroundColor]="'#E8F3F1'" />
    </div>
  </div>
</div>
